import { render, staticRenderFns } from "./menu2_video_clip_q.vue?vue&type=template&id=53563a55&scoped=true"
import script from "./menu2_video_clip_q.vue?vue&type=script&lang=js"
export * from "./menu2_video_clip_q.vue?vue&type=script&lang=js"
import style0 from "./menu2_video_clip_q.vue?vue&type=style&index=0&id=53563a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53563a55",
  null
  
)

export default component.exports